import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function saveAccountValidationKycData(
  onSuccessEvent,
  onErrorEvent,
  validationData,
) {
  const response = await sendRequest(validationData)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  const url = urls.saveAccountValidationKycData

  const userData = await self.servicesVars.getUserData()
  const storeId = await self.servicesVars.getStoreId()

  console.log(data)
  const requestData = {
    id: storeId,
    firstName: userData.firstName,
    lastName: userData.lastName,
    companyName: data.companyName,
    countryCode: data.countryCode,
    addresss: data.addresss,
    state: data.state,
    city: data.city,
    postalCode: data.postalCode,
    phoneNumber: data.phoneNumber,
    commercialLicenceId: data.commercialLicenceId,
    website: data.website,
    pictures: data.pictures.map(picture => picture.url),
  }

  console.log(requestData)

  const response = await Network.sendPostRequest(url, requestData)
  return response
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    return {
      success: true,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  if (response.status.code === 0) {
    return {
      success: false,
      message: 'error',
      networkError: true,
    }
  }
  return {
    success: false,
    message: 'error',
  }
}

export { saveAccountValidationKycData }
